/*
 * @Description: 接口
 * @Date: 2024-11-14 13:27:10
 */
import http from '@/utils/http/axios';
import type { EntpAuthInfo, EntpRegInfo } from './types';
import { wwwConfig } from '@/utils/http/axios/content-type';

const yApiObj = {
  // isTransformRequestResult: false,
  // yapi: 1263
};

enum Api {
  entpAuthInfo = '/front-end/real/api/v1/entpAuthInfo', // 企业实名信息查询
  entpRegInfo = '/front-end/real/api/v1/entpRegInfo', // 注册企业信息
  reAuthFail = '/front-end/real/api/v1/reAuthEntp', // 企业实名认证失败-重新认证
  getAuthProtocol = '/front-end/real/api/v1/getAuthProtocol' // 企业实名协议
}

/**
 * @description: 企业实名信息查询
 * @param {*} params
 * @returns {*}
 */
export const entpAuthInfo: EntpAuthInfo = (params?) =>
  http.request(
    {
      url: Api.entpAuthInfo,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );

/**
 * @description: 注册企业信息
 * @param {*} params
 * @returns {*}
 */
export const entpRegInfo: EntpRegInfo = params =>
  http.request(
    {
      url: Api.entpRegInfo,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * @description: 企业实名认证失败-重新认证
 * @param {*} params
 * @returns {*}
 */
export const reAuthFail = (params?) =>
  http.request(
    {
      url: Api.reAuthFail,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/**
 * @description: 企业实名协议
 * @param {*} params
 * @returns {*}
 */
export const getAuthProtocol = (params?) =>
  http.request(
    {
      url: Api.getAuthProtocol,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
